<template>
  <div>
    <div>
      <el-form :disabled="!isOk" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="书名" width="200" show-overflow-tooltip/>
        <el-table-column prop="sn" label="序列号" width="500" show-overflow-tooltip/>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="名称" prop="name" :rules="[{required: true, message: '名称为空'}]">
          <el-input v-model="form.name" maxlength="200" style="width: 580px"></el-input>
        </el-form-item>
        <el-form-item label="序列号" prop="sn">
          <el-input type="textarea" :rows="5" v-model="form.sn" maxlength="200" style="width: 580px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取消</el-button>
        <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
        <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'
import global from '../components/Global'

export default {
  name: 'Sn',
  data () {
    return {
      isOk: false,
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      param: {},
      tableData: [],
      form: {}
    }
  },
  created () {
    if (global.uid <= 0 || global.token === '') {
      this.$router.push('/')
      return
    }
    this.list()
  },
  methods: {
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.id = 0
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'sn/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'sn/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res)
            }
          }
        )
      })
    },
    handleAdd () {
      this.form = {}
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        this.form.id = row.id
        http.post(global.url0 + 'sn/del/', this.form).then(
          res => {
            if (res === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败')
            }
          }
        )
      })
    },
    list () {
      this.isOk = false
      this.tableData = []
      this.param.uid = global.uid
      this.param.token = global.token

      http.post(global.url0 + 'sn/get/', this.param).then(
        res => {
          // console.log(res)
          let resStr = res.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }

          this.tableData = res
          this.isOk = true
        }
      )
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'Sn')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Sn.vue